import { atom } from "jotai";
import { createDerivedWritableAtom } from "../../../utils";
import { videoSDKAtom } from "../../core/atoms";
import { ACTIVE_SPEAKER_THRESHOLD } from "../../core/room/participant/constants";
import { localAudioContextAtom } from "../../core/room/participant/media/atoms";
import { LocalMediaStatus } from "../../core/types";

export const localAudioContextStatsAtom = createDerivedWritableAtom(
  videoSDKAtom,
  "localAudioContextStats",
);

export const isSpeakingAtom = atom((get) => {
  const { status: localAudioStatus } = get(localAudioContextAtom);
  const localAudioTrackStats = get(localAudioContextStatsAtom);
  const audioLevel = localAudioTrackStats?.audioLevel ?? 0;

  return (
    localAudioStatus === LocalMediaStatus.READY &&
    audioLevel >= ACTIVE_SPEAKER_THRESHOLD
  );
});
